module.exports = __webpack_public_path__ + "static/media/logo.6f1f0100.png";